import { initModals } from "flowbite";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "../../store";
import { ChangePage } from "../../store/reducers/menu";
import P2PBetCard from "../P2PBetCard";

export default function P2PJoinModal({ data }) {
    // useEffect(() => {
    //   if (!window.FlowbiteInstances.instanceExists("Modal", "p2p-modal")) {
    //     initModals();
    //   }
    //   return () => {
    //     window.FlowbiteInstances.getInstance(
    //       "Modal",
    //       "p2p-modal"
    //     ).destroyAndRemoveInstance();
    //   };
    // }, []);
    const dispatch = useDispatch();

    return (
        <div
            id="p2p-join-modal"
            tabIndex={-1}
            aria-hidden="true"
            style={{ backgroundColor: "rgba(22,22,22,0.8)" }}
            className="flex justify-center items-center fixed top-0 left-0 right-0 z-50 w-full p-4 overflow-x-hidden overflow-y-auto md:inset-0 h-screen"
            data-modal-backdropclasses="bg-yellow-700"
        >
            <div className="relative w-full max-w-md max-h-full">
                <button
                    type="button"
                    className="absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ml-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                    data-modal-hide="p2p-join-modal"
                    onClick={() => {
                        dispatch(ChangePage(""))
                    }}
                >
                    <svg
                        className="w-3 h-3"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 14 14"
                    >
                        <path
                            stroke="currentColor"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                        />
                    </svg>
                    <span className="sr-only">Close modal</span>
                </button>
                <P2PBetCard />
            </div>
        </div>
    );
}
